export default __webpack_public_path__ + "static/media/alex.ca549fe2.jpg";